import { getSessionStorage } from '../../utils/sessionStorage'

import { isNonEmptyString, isObject } from '@/utils/checks'
import normalizeSearchState from './normalizeSearchState'
import { SearchState } from './types'
import { CustomeSearchState } from '@/types/models'
import { getSessionStorageSearchState } from '@/utils/search/searchState'

interface Taxonomy {
  type: string
  label: string
  remove?: boolean
}
export interface GlobalFilterableTaxonomy {
  type: string
  global: boolean
  title: string
}

interface RefineSearchStateFunction {
  (
    props: {
      taxonomy: Taxonomy
    },
    fromFacetOrLocationPage: boolean
  ): Partial<CustomeSearchState>
}

const refineSearchState: RefineSearchStateFunction = (
  { taxonomy },
  fromFacetOrLocationPage = false
) => {
  const searchState: CustomeSearchState = getSessionStorageSearchState() || {}
  const globalFilterableTaxonomy = (getSessionStorage(
    'globalFilterableTaxonomy'
  ) || []) as Array<GlobalFilterableTaxonomy>

  if (!isObject(taxonomy) || !taxonomy.type || !taxonomy.label) {
    return searchState
  }

  const refinementList = searchState?.refinementList || {}

  const filterToRefine = refinementList[taxonomy.type] || []

  const filterToRefineNormalized = Array.isArray(filterToRefine)
    ? filterToRefine
    : [filterToRefine]

  const isLocationTaxonomy = taxonomy.type === 'locations'
  const isGlobal = globalFilterableTaxonomy.some(
    (globalTaxonomy) =>
      globalTaxonomy.type === taxonomy.type &&
      globalTaxonomy.title === taxonomy.label
  )
  const isFirstAndOnlyFilter =
    Object.keys(refinementList).length === 0 &&
    !isNonEmptyString(searchState.locationName)

  const refinedSearchState: Partial<SearchState> = {
    ...searchState,
    refinementList: {
      ...refinementList,
      [taxonomy.type]: Array.from(
        new Set([...filterToRefineNormalized, taxonomy.label])
      ).filter((label) => !(taxonomy.remove && label == taxonomy.label)),
      ...(!isGlobal &&
        !isLocationTaxonomy &&
        isFirstAndOnlyFilter && { locations: 'United States' }),
      ...(fromFacetOrLocationPage && { locations: [] })
    },
    configure: {
      ...searchState.configure,
      page: 0
    }
  }

  return normalizeSearchState(refinedSearchState)
}

export default refineSearchState
